import { Album } from '@/models/album';
import { GalleryDialog } from './gallery-dialog';
import { useAlbum } from '@/hooks/use-album';

type GalleryItemProps = {
    albumId: Album['id'];
};

export const GalleryItem = (props: GalleryItemProps) => {
    const { data, error } = useAlbum(props.albumId);

    if (!data || error) {
        return null;
    }

    return (
        <GalleryDialog title={data.title} images={data.images}>
            <button type="button" className="group flex cursor-pointer flex-col gap-2">
                <div className="aspect-album max-w-full overflow-clip rounded-md border">
                    <img
                        src={data.images[0].src}
                        alt={data.title}
                        className="size-full rounded-sm object-cover transition-transform hover:duration-500 group-hover:scale-110"
                    />
                </div>
                <div className="flex flex-col gap-0.5 text-left">
                    <div className="line-clamp-1 text-base font-medium">{data.title}</div>
                    <div className="line-clamp-1 text-xs text-muted-foreground">
                        {data.images.length} zdjęć
                    </div>
                </div>
            </button>
        </GalleryDialog>
    );
};
